import React, { useState } from 'react';
import { CreditCard } from '../../components';
import { motion } from 'framer-motion';
import { Input, Select, Typography, Image, message, Button, Form } from 'antd';
import { GlobalOutlined, IdcardOutlined, UserOutlined } from '@ant-design/icons';
import _bank from './bank.json';
import InputMask from 'react-input-mask';
export default function Three({ onOk }) {
  const [state, setState] = useState({
    bankName: '',
    logo: '',
    number: '',
    name: '',
    date: '',
    card_id: '',
  });
  async function onConfirm() {
    if (!state.bankName || !state.name || !state.number || !state.card_id) {
      message.error('요구된 모든 정보를 제공해 주세요');
      return;
    }
    onOk({ bank: state });
  }
  return (
    <motion.div
      initial={{ opacity: 0.3, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      className="bank-form-container"
    >
      <Typography.Text strong style={{ fontSize: 17, padidng: 10 }}>
        수취인 은행 정보
      </Typography.Text>

      <CreditCard
        logoBank={state.logo}
        name={state.name}
        bankNumber={state.number}
        nameBank={state.bankName}
        bankDate={state.date}
      />
      <div style={{ padding: 20 }}>
        <Input
          size="large"
          placeholder="계좌 번호"
          type="number"
          prefix={<GlobalOutlined className="information-icon" />}
          value={state.number}
          onChange={(e) => setState({ ...state, number: e.target.value })}
          className="bank-input"
        />

        <Input
          value={state.name}
          onChange={(e) => setState({ ...state, name: e.target.value })}
          size="large"
          placeholder="계좌 소유자 이름"
          prefix={<UserOutlined className="information-icon" />}
          className="bank-input"
        />
        <Select
          className="select-bank"
          placeholder="수취은행 선택"
          onChange={(e) =>
            setState({
              ...state,
              bankName: e.split('@')[0],
              logo: e.split('@')[1],
            })
          }
        >
          {_bank.banksnapas.map((item) => (
            <Select.Option value={`${item.shortName}@${item.logo}`}>
              <div>
                <Typography.Text strong> {item.shortName}</Typography.Text> -{' '}
                <Typography.Text>{item.en_name}</Typography.Text>
              </div>
              {item.logo && (
                <Image src={item.logo} preview={false} width="20%" />
              )}
            </Select.Option>
          ))}
        </Select>
        <Input
          value={state.card_id}
          onChange={(e) => setState({ ...state, card_id: e.target.value })}
          size="large"
          placeholder="카드 코드"
          prefix={<IdcardOutlined className="information-icon" />}
          className="bank-input"
        />
        <div className="send-request-div">
          <Button className="confirm-btn" onClick={onConfirm}>
            <Typography.Text className="confirm-div-title">
              요청 보내기
            </Typography.Text>
          </Button>
        </div>
      </div>
    </motion.div>
  );
}
